export function useFilesize(fileSize) {
  if (!fileSize)
    return;

  let bytes = fileSize.toString().replace(/[^0-9.]/g, '');
  let sizes = ["B", "KB", "MB", "GB", "TB"];
  bytes = parseInt(bytes);
  if (bytes <= 0 || isNaN(bytes)) return "0 B";
  let i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}